import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { RealtimeUpdates } from "@/pages/3d/live/RealtimeUpdates";

export const Route = createFileRoute("/demo/3d/live/realtime")({
  component: () => (
    <BabylonSceneWrapper>
      <RealtimeUpdates />
    </BabylonSceneWrapper>
  ),
});
